import { format } from 'date-fns';
const calculateDPP = (dum) => {
  if (!dum) return null;
  const dataDUM = new Date(dum);
  const dpp = new Date(dataDUM.setDate(dataDUM.getDate() + 280)); // 40 semanas
  return format(dpp, 'dd/MM/yyyy');
};

const calculateGestationalAge = (dum) => {
  if (!dum) return null;
  const today = new Date();
  const dataDUM = new Date(dum);
  if (isNaN(dataDUM.getTime())) return null;

  const diference = today - dataDUM;
  return Math.floor(diference / (1000 * 60 * 60 * 24 * 7)); // in weeks
};

const formatDateToISO = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') return null;
  const [day, month, year] = dateStr.split('/');
  if (!day || !month || !year) return null;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};



export {
  calculateDPP,
  calculateGestationalAge,
  formatDateToISO,
}